import { EnrollView } from "../_components";

export default function DevicesEnrollPage() {
  return <EnrollView />;
}
